import ConverterClass from '../../utils/converter';

class Converter extends ConverterClass {

}

export default new Converter();